import { useWizard } from '../../../context/WizardContext';
import { PaperCard } from '../../../components/wizard/PaperCard';
import { NavigationButtons } from '../../../components/wizard/NavigationButtons';
import { useTranslation } from '../../../context/LanguageContext';

export function Step2Paper() {
  const { state, setPaper } = useWizard();
  const { t } = useTranslation();
  const papers = state.selectedSubject?.papers ?? [];

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-xl font-bold text-white">{t('wizard.paperTitle')}</h2>
        <p className="text-sm text-slate-500 mt-1">
          {t('wizard.paperSubtitle', { subject: state.selectedSubject?.name ?? '' })}
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {papers.map((paper) => (
          <PaperCard
            key={paper.id}
            paper={paper}
            isSelected={state.selectedPaper?.id === paper.id}
            onSelect={setPaper}
          />
        ))}
      </div>
      <NavigationButtons />
    </div>
  );
}
